@if (isOpen) {
  <div class="overlay">
    <div
      class="modal border-t-4 p-5 rounded-lg bg-white shadow-md"
      [ngClass]="{
        'border-green-500': type === 'success',
        'border-red-500': type === 'error',
        'border-blue-500': type === 'information'
      }"
    >
      <!-- Title -->
      <h2
        class="text-lg font-semibold mb-2"
        [ngClass]="{
          'text-green-600': type === 'success',
          'text-red-600': type === 'error',
          'text-blue-600': type === 'information'
        }"
      >
        {{ title }}
      </h2>

      <!-- Message -->
      <p class="text-gray-700 mb-4">
        {{ message }}
      </p>

      <!-- Spinner -->
      @if (isLoading) {
        <div class="flex justify-center mb-4">
          <span class="spinner"></span>
        </div>
      }

      <!-- Button -->
      <button
        (click)="onClose()"
        [disabled]="isLoading"
        class="w-full text-white px-4 py-2 rounded transition"
        [ngClass]="{
          'bg-green-600 hover:bg-green-700': type === 'success',
          'bg-red-600 hover:bg-red-700': type === 'error',
          'bg-blue-600 hover:bg-blue-700': type === 'information'
        }"
      >
        {{ isLoading ? 'Processing...' : buttonText }}
      </button>
    </div>
  </div>
}